import React from 'react';

const GithubIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0C5.37 0 0 5.373 0 12c0 5.303 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222 0 1.606-.015 2.896-.015 3.286 0 .322.216.694.825.576C20.565 21.795 24 17.298 24 12c0-6.627-5.373-12-12-12z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);
const WhatsappIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const STATS = [
  { value: '5+',     label: 'Years Exp.',   sub: 'SaaS · Logistics' },
  { value: '10+',    label: 'Apps & WEB Shipped', sub: 'End-to-end'       },
  { value: '~200ms', label: 'API Speed',    sub: 'Was 20 seconds'   },
];

const SOCIALS = [
  { icon: <GithubIcon />,   href: 'https://github.com/IlyasDev123',                       label: 'GitHub'   },
  { icon: <LinkedInIcon />, href: 'https://www.linkedin.com/in/muhammad-ilyas-873a17178', label: 'LinkedIn' },
  { icon: <WhatsappIcon />, href: 'https://wa.me/923490523972',                           label: 'WhatsApp' },
];

const STACK = ['Laravel', 'FastAPI', 'React', 'Vue.js', 'React Native', 'ChatGPT · Gemini'];

export default function Hero() {
  return (
    <section className="relative min-h-screen bg-slate-950 flex items-center overflow-hidden">

      <div className="absolute inset-0 dot-grid opacity-100 pointer-events-none" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 80% 80% at 50% 50%, transparent 20%, #020617 85%)' }}
      />
      <div className="absolute top-1/3 right-1/4 w-64 sm:w-96 h-64 sm:h-96 bg-sky-500/8 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/3 left-1/4 w-48 sm:w-64 h-48 sm:h-64 bg-indigo-500/6 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-24 lg:py-32 w-full relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          {/* ── Left ── */}
          <div>
            <p className="font-mono text-sky-400 text-xs sm:text-sm tracking-[0.2em] mb-4 sm:mb-6 flex items-center gap-3">
              {/* <span className="w-6 sm:w-8 h-px bg-sky-400" /> */}
              Hello, World! I am
            </p>

            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold leading-[1.05] text-slate-100 mb-4 sm:mb-5">
              Muhammad<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-sky-300">
                Ilyas
              </span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-slate-300 font-semibold mb-3">
              Senior Full Stack &amp; AI Systems Engineer
            </p>

            {/* Status badges */}
            <div className="flex flex-wrap gap-2 mb-5 sm:mb-8">
              <span className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400">
                <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse" />
                Available · 30-day notice
              </span>
              <span className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full bg-sky-500/10 border border-sky-400/20 text-sky-300">
                <span className="w-1.5 h-1.5 bg-sky-400 rounded-full" />
                Devstudio · Lahore, PK
              </span>
            </div>

            <p className="text-slate-400 text-sm sm:text-base leading-relaxed mb-3 max-w-lg">
              Full-stack engineer building SaaS, logistics, and fintech products end to end.
              Known for turning slow, aging systems into fast ones — rebuilt a legacy API layer that brought
              <span className="text-slate-200 font-semibold"> 20-second responses under 200ms</span>.
            </p>
            <p className="text-slate-500 text-sm leading-relaxed mb-6 sm:mb-8 max-w-lg">
              Applies LLMs where they add real value — integrating ChatGPT and Gemini for invoice
              processing, document extraction, and financial analysis.
            </p>

            {/* Tech chips */}
            <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-6 sm:mb-9">
              {STACK.map(t => (
                <span key={t} className="font-mono text-[10px] sm:text-[11px] text-sky-300 bg-sky-400/8 border border-sky-400/20 px-2.5 sm:px-3 py-1 sm:py-1.5 rounded cursor-default">
                  {t}
                </span>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-3 sm:gap-4 mb-6 sm:mb-9">
              <a
                href="/Muhammad_Ilyas_CV.pdf"
                download
                className="inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-400 text-white font-semibold px-5 sm:px-7 py-2.5 sm:py-3 rounded-lg transition-all hover:shadow-lg hover:shadow-sky-500/20 text-sm"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download Resume
              </a>
              <a href="#projects" className="inline-flex items-center gap-2 text-slate-400 hover:text-sky-400 font-medium text-sm transition-colors">
                View Projects
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </a>
            </div>

            {/* Socials */}
            <div className="flex items-center gap-3 sm:gap-4">
              <span className="text-slate-700 text-[10px] font-mono uppercase tracking-[0.15em]">Find me on</span>
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-slate-800/80 border border-slate-700 hover:border-sky-500/60 hover:bg-sky-500/10 text-slate-400 hover:text-sky-400 flex items-center justify-center transition-all"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Right ── */}
          <div className="flex flex-col items-center gap-6 sm:gap-8 mt-4 lg:mt-0">

            {/* Photo */}
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-sky-500/20 to-indigo-500/10 rounded-3xl blur-2xl" />
              <div className="relative w-60 h-60 sm:w-72 sm:h-72 lg:w-80 lg:h-80 rounded-2xl overflow-hidden border border-slate-700/80 shadow-2xl shadow-black/60">
                <img
                  src="/images/profile.jpeg"
                  alt="Muhammad Ilyas"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent" />
                <div className="absolute bottom-0 inset-x-0 px-4 pb-3 sm:px-5 sm:pb-4">
                  <p className="text-white font-bold text-base sm:text-lg leading-tight drop-shadow-lg">Muhammad Ilyas</p>
                  <p className="text-sky-300 text-[10px] sm:text-xs font-mono mt-0.5 drop-shadow">Senior Full Stack &amp; AI Engineer</p>
                </div>
              </div>

              {/* Open to work badge */}
              <div className="absolute -bottom-3 -right-3 sm:-bottom-4 sm:-right-4 bg-slate-900 border border-slate-700 rounded-xl px-3 py-2 sm:px-4 sm:py-3 shadow-2xl shadow-black/60">
                <div className="flex items-center gap-2">
                  <div className="relative shrink-0">
                    <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-emerald-400 rounded-full" />
                    <div className="absolute inset-0 bg-emerald-400 rounded-full animate-ping opacity-40" />
                  </div>
                  <span className="text-xs sm:text-sm font-semibold text-slate-200 whitespace-nowrap">Open to work</span>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-2 sm:gap-3 w-full max-w-[280px] sm:max-w-sm">
              {STATS.map(s => (
                <div
                  key={s.label}
                  className="bg-slate-900/80 border border-slate-800 hover:border-sky-500/30 rounded-xl p-2.5 sm:p-4 text-center transition-all group backdrop-blur-sm"
                >
                  <div className="text-lg sm:text-xl lg:text-2xl font-extrabold text-sky-400 group-hover:scale-110 transition-transform origin-center mb-0.5 sm:mb-1">
                    {s.value}
                  </div>
                  <div className="text-[9px] sm:text-[10px] text-slate-400 font-semibold uppercase tracking-wide leading-tight">
                    {s.label}
                  </div>
                  <div className="text-[9px] sm:text-[10px] text-slate-600 mt-0.5 leading-tight hidden sm:block">
                    {s.sub}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden lg:flex flex-col items-center">
          <a href="#about" className="text-slate-700 hover:text-sky-400 transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
